import { authFetch } from 'src/auth/utils';
import { envVariables } from 'src/common/utils/envVariables';
import { ESim } from '../models/esim';

type FetchESimsArgs = {
  searchEid?: string;
};

export const fetchESims = async ({ searchEid }: FetchESimsArgs, signal?: AbortSignal) => {
  const urlQuery = new URLSearchParams();
  if (searchEid) {
    urlQuery.append('searchEid', searchEid);
  }

  const searchParamsQuery = urlQuery.toString();

  let ENPOINT: string = `${envVariables.VITE_ESIMS_INGESTION_API}/e-sims`;
  if (searchParamsQuery) {
    ENPOINT += `?${urlQuery.toString()}`;
  }

  const esimProfilesResponse = await authFetch(ENPOINT, {
    signal,
  });

  const esims: ESim[] = await esimProfilesResponse.json();

  return {
    totalNumberOfItems: esims.length,
    items: esims,
  };
};
